import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { I18nInfo } from '../models/i18n.model';
import {
  LanguageSelectorDialogComponent,
  LanguageSelectorDialogContext,
} from '../pages/i18n/language-selector-dialog.component';
import { MeDetailsDialogComponent, MeDetailsDialogContext } from '../pages/me/me-details-dialog.component';
import { I18nService } from '../services/i18n.service';
import { KeycloakService } from '../services/keycloak.service';
import { ModalService } from '../services/modal.service';
import { NAVBAR_LINK, COMPANY_NAME } from '../utils/env';

import { CapitalizePipe } from '../pipes/capitalize.pipe';
import { TranslatePipe } from '../pipes/translate.pipe';

@Component({
  standalone: true,
  selector: 'top-nav',
  templateUrl: 'topnav.html',
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet, BsDropdownModule, CapitalizePipe, TranslatePipe],
})
export class TopNavComponent implements OnInit {
  private token: any;
  i18nInfo: I18nInfo;
  navbarLink = NAVBAR_LINK;
  companyName = COMPANY_NAME;

  constructor(
    private modal: ModalService,
    private i18nService: I18nService,
  ) {
    // l'auth Keycloak est avant l'init standard de Angular
    this.token = KeycloakService.auth.authz.tokenParsed;
  }

  ngOnInit() {
    // i18nInfo utilise l'init standard de Angular
    this.i18nInfo = this.i18nService.i18nInfo;
  }

  showProfile() {
    console.log('showProfile');
    const context = new MeDetailsDialogContext();
    context.showClose = true;
    context.isBlocking = false;
    context.size = 'lg';
    this.modal.open(MeDetailsDialogComponent, context);
  }

  showLanguageSelector() {
    console.log('showLanguageSelector');
    const context = new LanguageSelectorDialogContext();
    context.showClose = true;
    context.isBlocking = false;
    context.size = 'lg';
    this.modal.open(LanguageSelectorDialogComponent, context);
  }

  logout() {
    KeycloakService.logout();
  }
}
